import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Table,
  Input,
  Button,
  message,
  Modal,
  Tag,
  Radio,
  Form,
  DatePicker,
  Dropdown,
  Menu,
  Tabs,
  InputNumber,
  Select,
  Switch,
  Badge,
} from "antd";
import {
  SearchOutlined,
  CloudDownloadOutlined,
  DownOutlined,
  CopyOutlined,
  PlusOutlined,
  RedoOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Title from "components/Title/Title";
import { withAppContext } from "contexts/AppContext/AppContext";
import {
  buildBillingManagementUri,
  buildBillingListUri,
  buildBillingUri,
} from "utils/routes";
import Highlighter from "react-highlight-words";
import moment from "moment";
import Currency from "react-currency-formatter";
import { PrimaryColor, ScreenSize, env } from "utils/constants";
import {
  adviseeBirthday,
  adviseeStatistic,
  adviseeChart,
} from "apis/dashboard";
import { CSVLink } from "react-csv";
import { useFetchConstant } from "../../apis/constant";
import {
  archiveProduct,
  createProduct,
  getAllProducts,
  patchProduct,
  syncProducts,
} from "apis/product";
import {
  checkVoucherCodeExist,
  createVoucher,
  deleteVoucher,
  getAllVouchers,
  patchVoucher,
} from "apis/voucher";
import {
  adminCancelUserSubscription,
  getBillingListFromDatabase,
  getBillingListFromStripe,
} from "apis/billing";
import { getAllInvoices, getInvoice } from "apis/invoice";
import Paragraph from "antd/lib/typography/Paragraph";
import Locale from "react-intl-universal";

const BillingManagement = ({ isAdmin }) => {
  const history = useHistory();

  const [form] = Form.useForm();
  const [subscriptionForm] = Form.useForm();
  const [voucherForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [billingLoading, setBillingLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [subscriptionMode, setSubscriptionMode] = useState("Add");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [subscriptionVisible, setSubscriptionVisible] = useState(false);

  const [voucherMode, setVoucherMode] = useState("Add");
  const [voucherId, setVoucherId] = useState("");
  const [voucherVisible, setVoucherVisible] = useState(false);
  const [voucherUsageVisible, setVoucherUsageVisible] = useState(false);

  const [deductAmountVisible, setDeductAmountVisible] = useState(false);

  const [dateRange, setDateRange] = useState([
    moment().subtract(1, "month").startOf("day"),
    moment().endOf("day"),
  ]);
  const [dateRangeInvoice, setDateRangeInvoice] = useState([
    moment().subtract(1, "month").startOf("day"),
    moment().endOf("day"),
  ]);

  const [data, setData] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [voucherData, setVoucherData] = useState([]);
  const [billingData, setBillingData] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [voucherUsageData, setVoucherUsageData] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [searchInput, setSearchInput] = useState("");

  const [processingFeeEnabled, setProcessingFeeEnabled] = useState(false);

  const [csv_data, set_csv_data] = useState([]);
  const [csv_header, set_csv_header] = useState([
    {
      label: "Creation_Date",
      key: "createdAt",
    },
    {
      label: "Order_Number",
      key: "orderNumber",
    },
    {
      label: "Invoice_Number",
      key: "invoiceNumber",
    },
    {
      label: "Full_Name",
      key: "name",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Subscription",
      key: "subscription",
    },
    {
      label: "Plan",
      key: "plan",
    },
    {
      label: "Total",
      key: "total",
    },
    {
      label: "Renewal_Date",
      key: "renewalDate",
    },
    {
      label: "Status",
      key: "status",
    },
  ]);

  const [csvDataVoucherUsage, setCsvDataVoucherUsage] = useState([]);
  const [csvHeaderVoucherUsage, setCsvHeaderVoucherUsage] = useState([
    {
      label: "Claimed_Date",
      key: "updatedAt",
    },
    {
      label: "Order_Number",
      key: "orderNumber",
    },
    {
      label: "Invoice_Number",
      key: "invoiceNumber",
    },
    {
      label: "Voucher_Name",
      key: "voucherName",
    },
    {
      label: "Voucher_Code",
      key: "voucherCode",
    },
    {
      label: "Full_Name",
      key: "name",
    },
    {
      label: "Email",
      key: "email",
    },
  ]);

  const [csvDataInvoice, setCsvDataInvoice] = useState([]);
  const [csvHeaderInvoice, setCsvHeaderInvoice] = useState([
    {
      label: "Invoice_Date",
      key: "createdAt",
    },
    {
      label: "Order_Number",
      key: "orderNumber",
    },
    {
      label: "Invoice_Number",
      key: "invoiceNumber",
    },
    {
      label: "Full_Name",
      key: "name",
    },
    {
      label: "Email",
      key: "email",
    },
    {
      label: "Total",
      key: "total",
    },
  ]);

  const { isLoading: isRolesLoading, selection: roles } = useFetchConstant(
    "roles"
  );

  const onBackButtonClick = () => history.push(buildBillingUri());

  useEffect(() => {
    getProductList();
    getUnfilteredProductList();
    getVoucherList();

    BillingList();
    InvoiceList();

    return () => {};
  }, []);

  useEffect(() => {
    if (subscriptionVisible && subscriptionMode === "Add") {
      subscriptionForm.setFieldsValue({
        description: [""],
      });
    }
  }, [subscriptionVisible]);

  const getProductList = async () => {
    setLoading(true);
    const mode = "admin";
    const res = await getAllProducts(mode);

    if (res.status === 200) {
      setData(res.products);
      setLoading(false);
    }

    console.log("res getProductList", res);
  };

  const getUnfilteredProductList = async () => {
    setLoading(true);
    const mode = "unfiltered";
    const res = await getAllProducts(mode);

    if (res.status === 200) {
      setAllProducts(res.products);
      setLoading(false);
    }

    console.log("res getUnfilteredProductList", res);
  };

  const getVoucherList = async () => {
    setLoading(true);
    const res = await getAllVouchers();

    if (res.status === 200) {
      setVoucherData(res.vouchers);
      setLoading(false);
    }

    console.log("res getVoucherList", res);
  };

  const CheckVoucherCodeExists = async (rule, value) => {
    console.log(rule);
    console.log(value);

    const res = await checkVoucherCodeExist(value);

    console.log("res CheckVoucherCodeExists", res);

    if (voucherMode === "Add") {
      if (res.exists === false) {
        return Promise.resolve();
      } else {
        return Promise.reject(
          Locale.get("Billing.voucherTabTable.voucherForm.voucherCodeExist")
        );
      }
    }
  };

  const validateSpecialCharacters = async (rule, value) => {
    console.log(rule);
    console.log(value);

    // frontend
    if (!/^[a-zA-Z0-9]*$/.test(value)) {
      return Promise.reject(
        "Voucher Code should only contain alphabets and numbers."
      );
    } else {
      return Promise.resolve();
    }
  };

  const BillingList = async (e) => {
    setBillingLoading(true);

    let payload;

    if (e) {
      const start = moment(e[0]).unix();
      const end = moment(e[1]).unix();

      payload = { start: start, end: end };
    } else {
      const start = moment(dateRange[0]).unix();
      const end = moment(dateRange[1]).unix();

      payload = { start: start, end: end };
    }

    // const res = await getBillingListFromStripe();
    // if (res.status === 200) {
    //   setBillingData(res.invoices);
    //   setBillingLoading(false);
    // }

    const res = await getBillingListFromDatabase(payload);
    if (res.status === 200) {
      const buffer = [...res.billings];

      buffer.forEach((invoice) => {
        invoice.created = invoice.invoice.created;
        invoice.orderNumber = invoice.invoice.number;
        invoice.invoiceStatus = invoice.invoice.status;
        invoice.stripeInvoicePDF = invoice.invoice.invoice_pdf;
        invoice.invoiceNumber = invoice.invoice?.metadata?.invoiceNumber;
        invoice.customer_name = invoice.invoice.customer_name;
        invoice.customer_email = invoice.invoice.customer_email;
        invoice.product_name = invoice.productDetail.name;
        invoice.subscription_interval = invoice.subscriptionDetail.interval;
        invoice.total = invoice.invoice.total;
        invoice.currency = invoice.invoice.currency;
        invoice.renewalDate = invoice.subscriptionDetail.current_period_end;
        invoice.subscriptionStatus = invoice.subscriptionDetail.status;
        invoice.subscriptionCancelAtPeriodEnd =
          invoice.subscriptionDetail.cancel_at_period_end;
      });

      setBillingData(buffer);

      console.log("buffer", buffer);
      setBillingLoading(false);
    }
  };

  const InvoiceList = async (e) => {
    setInvoiceLoading(true);

    let payload;

    if (e) {
      const start = moment(e[0]).unix();
      const end = moment(e[1]).unix();

      payload = { start: start, end: end };
    } else {
      const start = moment(dateRangeInvoice[0]).unix();
      const end = moment(dateRangeInvoice[1]).unix();

      payload = { start: start, end: end };
    }

    const res = await getAllInvoices(payload);

    if (res.status === 200) {
      setInvoiceData(res.invoices);
      setInvoiceLoading(false);
    }
  };

  const deleteSubscription = async (id) => {
    archiveProduct(id)
      .then((res) => {
        console.log("res archiveProduct", res);
        if (res.status === 200) {
          message.success(
            Locale.get(
              "Billing.billingManagement.billManagementForm.delSuccessMsg"
            )
          );

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((ex) => {
        Modal.error({
          title: ex.message,
        });
      });
  };

  const handleDeleteVoucher = async (voucherId, voucherCode) => {
    const payload = {
      voucherCode: voucherCode,
    };

    deleteVoucher(voucherId, payload)
      .then((res) => {
        console.log("res deleteVoucher", res);
        if (res.status === 200) {
          message.success("Delete Voucher Successful!");

          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      })
      .catch((ex) => {
        Modal.error({
          title: ex.message,
        });
      });
  };

  const SendInvoice = async (e) => {
    // const res = await sendInvoice(e);
    // console.log("res", res)

    message.success("Send Invoice Successful!");

    // BillingList();
  };

  const HandleSubscription = async () => {
    const values = await subscriptionForm.validateFields();

    if (!values.trial) {
      // delete values.trialDuration;
      delete values.trialEndDate;
    } else {
      values.trialEndDate = values.trialEndDate.set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 0,
      });

      values.trialEndDate = values.trialEndDate.unix();
    }

    values.pricePerMonth = Math.floor(values.pricePerMonth * 100);
    values.pricePerYear = Math.floor(values.pricePerYear * 100);

    console.log("values", values);

    Modal.confirm({
      title: subscriptionId
        ? Locale.get("Billing.billingManagement.modalConfirmEditSubscription")
        : Locale.get("Billing.billingManagement.modalConfirmAddSubscription"),
      onOk: () => {
        if (subscriptionMode === "Add") {
          createProduct(values)
            .then((res) => {
              console.log("res createProduct", res);
              if (res.status === 200) {
                setSubscriptionVisible(false);

                message.success(
                  Locale.get(
                    "Billing.billManagement.billManagementForm.addSuccessMsg"
                  )
                );

                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            })
            .catch((ex) => {
              Modal.error({
                title: ex.message,
              });
            });
        } else {
          patchProduct(subscriptionId, values)
            .then((res) => {
              console.log("res patchProduct", res);
              if (res.status === 200) {
                setSubscriptionVisible(false);
                message.success("Edit Subscription Successful!");

                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            })
            .catch((ex) => {
              Modal.error({
                title: ex.message,
              });
            });
        }
      },
    });
  };

  const HandleVoucher = async () => {
    const values = await voucherForm.validateFields();

    if (values.voucherDuration !== "repeating") {
      delete values.durationInMonth;
    }

    if (!values.limitRedeemDate) {
      delete values.voucherEndDate;
    } else {
      const unixTimestamp = moment(values.voucherEndDate).unix();

      values.voucherEndDate = unixTimestamp;
    }

    if (!values.limitRedeemUsage) {
      delete values.voucherUsage;
    }

    if (values.voucherType === "amount_off") {
      values.amountOff.discountAmount = Math.floor(
        values.amountOff.discountAmount * 100
      );
    }

    if (values.productsApplied.length > 0) {
      var buffer = [...values.productsApplied];

      var newBuffer = [];

      buffer.forEach((element) => {
        element = JSON.parse(element);

        newBuffer.push(element);
      });

      values.productsApplied = newBuffer;
    }

    console.log(values, "values");

    Modal.confirm({
      title: voucherId
        ? Locale.get(
            "Billing.voucherTabTable.voucherForm.modalConfirmEditVoucher"
          )
        : Locale.get(
            "Billing.voucherTabTable.voucherForm.modalConfirmAddVoucher"
          ),
      onOk: () => {
        if (voucherMode === "Add") {
          createVoucher(values)
            .then((res) => {
              console.log("res createVoucher", res);
              if (res.status === 200) {
                setVoucherVisible(false);
                message.success(
                  Locale.get(
                    "Billing.voucherTabTable.voucherForm.addVoucherSuccess"
                  )
                );
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            })
            .catch((ex) => {
              Modal.error({
                title: ex.message,
              });
            });
        } else {
          console.log("voucherId", voucherId);
          patchVoucher(voucherId, values)
            .then((res) => {
              console.log("res patchVoucher", res);
              if (res.status === 200) {
                setVoucherVisible(false);
                message.success(
                  Locale.get(
                    "Billing.voucherTabTable.voucherForm.editVoucherSuccess"
                  )
                );
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            })
            .catch((ex) => {
              Modal.error({
                title: ex.message,
              });
            });
        }
      },
    });
  };

  const HandleDeductAmount = async () => {
    const values = await form.validateFields();

    // const res = await sendInvoice(e);
    // console.log("res", res);

    Modal.confirm({
      title: "Confirm Deduct Amount?",
      onOk: () => {
        setDeductAmountVisible(false);
        message.success("Deduct Amount Successful!");
        // BillingList();
      },
    });
  };

  const generateCSV = () => {
    var order = [...billingData];
    var csv_data = [];

    for (let i = 0; i < order.length; i++) {
      const real_order = order[i];

      csv_data.push({
        createdAt: moment.unix(real_order.created).format("YYYY-MM-DD"),
        orderNumber: real_order.orderNumber,
        invoiceNumber: real_order.invoiceNumber,
        name: real_order.customer_name,
        email: real_order.customer_email,
        subscription: real_order.product_name,
        plan:
          real_order.subscription_interval === "month" ? "Monthly" : "Annually",
        total: "RM" + real_order.total / 100,
        renewalDate: moment.unix(real_order.renewalDate).format("YYYY-MM-DD"),
        status: real_order.invoiceStatus,
      });
    }

    set_csv_data(csv_data);

    return true;
  };

  const generateVoucherCSV = () => {
    var order = [...voucherUsageData];
    var csv_data = [];

    for (let i = 0; i < order.length; i++) {
      const real_order = order[i];
      // console.log(real_order);

      csv_data.push({
        updatedAt: real_order.updatedAt
          ? moment(real_order.updatedAt).format("DD-MMM-YYYY hh:mma")
          : "-",
        orderNumber: real_order.orderNumber,
        invoiceNumber: real_order.invoiceNumber,
        voucherName: real_order.voucherName,
        voucherCode: real_order.voucherCode,
        name: real_order.name,
        email: real_order.email,
      });
    }
    setCsvDataVoucherUsage(csv_data);
    return true;
  };

  const generateInvoiceCSV = () => {
    var order = [...invoiceData];
    var csv_data = [];

    for (let i = 0; i < order.length; i++) {
      const real_order = order[i];

      csv_data.push({
        createdAt: moment(real_order.createdAt).format("YYYY-MM-DD"),
        orderNumber: real_order.orderNumber,
        invoiceNumber: real_order.invoiceNumber,
        name: real_order.userName,
        email: real_order.userEmail,
        total: "RM" + real_order.amount / 100,
      });
    }

    setCsvDataInvoice(csv_data);

    return true;
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 7 },
      xl: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 16 },
      xl: { span: 16 },
    },
  };

  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 16, offset: 8 },
      xl: { span: 16, offset: 7 },
    },
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            setSearchInput(node);
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          {Locale.get("Billing.billingManagement.searchButton")}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          {Locale.get("Billing.billingManagement.resetButton")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          marginRight: 8,
          fontSize: 18,
          color: filtered ? "#ffc069" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      if (record[dataIndex]) {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      } else {
        return false;
      }
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput);
      }
    },
    render: (text) => {
      if (text) {
        return (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        );
      }
    },
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0"),
      dataIndex: "createdAt",
      key: "createdAt",
      defaultSortOrder: "descend",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),

      render: (v) => {
        return moment(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0a"),
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
      render: (v, d) => {
        let link = window.location.origin;
        let copyableText;

        if (!d.visible) {
          copyableText = `${link}/billing-subscription/special?productId=${d._id}`;
        } else {
          copyableText = `${link}/billing-subscription?productId=${d._id}`;
        }
        return (
          <div>
            <Paragraph
              copyable={{
                text: copyableText,
              }}
            >
              {v}
            </Paragraph>
            {d.recommended && (
              <Tag color="orange">
                {Locale.get("Billing.billingManagement.recommendedTag")}
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0b"),
      dataIndex: "description",
      key: "description",
      width: "30%",
      ...getColumnSearchProps("description"),
      render: (v) => {
        return v.map((description, index) => {
          return <div key={index}> - {description}</div>;
        });
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0c"),
      dataIndex: "pricePerMonth",
      key: "pricePerMonth",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.pricePerMonth - b.pricePerMonth,
      render: (v, d) => {
        return (
          <Currency
            quantity={v / 100}
            currency={d.currency}
            pattern="! #,##0.00"
          />
        );
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0d"),
      dataIndex: "pricePerYear",
      key: "pricePerYear",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.pricePerYear - b.pricePerYear,
      render: (v, d) => {
        return (
          <Currency
            quantity={v / 100}
            currency={d.currency}
            pattern="! #,##0.00"
          />
        );
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0e"),
      dataIndex: "processingFee",
      key: "processingFee",
      filterMultiple: false,
      filters: [
        {
          text: (
            <Badge
              status="success"
              text={Locale.get("Billing.billingManagement.badgeText_0a")}
            />
          ),
          value: true,
        },
        {
          text: (
            <Badge
              status="error"
              text={Locale.get("Billing.billingManagement.badgeText_0b")}
            />
          ),
          value: false,
        },
      ],
      onFilter: (value, record) => {
        return record.processingFee === value;
      },
      render: (value) => {
        switch (value) {
          case true:
            return (
              <Badge
                status="success"
                text={Locale.get("Billing.billingManagement.badgeText_0a")}
              />
            );

          default:
            return (
              <Badge
                status="error"
                text={Locale.get("Billing.billingManagement.badgeText_0b")}
              />
            );
        }
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0f"),
      dataIndex: "trialEndDate",
      key: "trialEndDate",

      sortDirections: ["descend", "ascend"],
      sorter: (a, b) =>
        moment.unix(a.trialEndDate) - moment(b.trialEndDate).unix(),

      render: (v) => {
        if (v) return moment.unix(v).format("YYYY-MM-DD");
        else return "-";
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0g"),
      dataIndex: "visible",
      key: "visible",
      filterMultiple: false,
      filters: [
        {
          text: (
            <Tag color="green">
              {Locale.get("Billing.billingManagement.visibleTag")}
            </Tag>
          ),
          value: true,
        },
        {
          text: (
            <Tag color="red">
              {Locale.get("Billing.billingManagement.hiddenTag")}
            </Tag>
          ),
          value: false,
        },
      ],
      onFilter: (value, record) => {
        return record.visible === value;
      },
      render: (value) => {
        switch (value) {
          case true:
            return (
              <Tag color="green">
                {Locale.get("Billing.billingManagement.visibleTag")}
              </Tag>
            );

          default:
            return (
              <Tag color="red">
                {Locale.get("Billing.billingManagement.hiddenTag")}
              </Tag>
            );
        }
      },
    },
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0h"),
      align: "center",
      render: (value, record) => {
        return (
          <Dropdown
            placement="bottomRight"
            trigger={["click"]}
            overlay={
              <Menu
                onClick={(e) => {
                  switch (e.key) {
                    case "editSubscription":
                      setSubscriptionMode("Edit");
                      setSubscriptionId(value._id);
                      setSubscriptionVisible(true);
                      subscriptionForm.setFieldsValue({
                        name: value.name,
                        description: value.description,
                        pricePerMonth: value.pricePerMonth / 100,
                        pricePerYear: value.pricePerYear / 100,
                        trial: value.trial,
                        // trialDuration: value.trial ? value.trialDuration : "",
                        trialEndDate: value.trial
                          ? moment.unix(value.trialEndDate)
                          : "",
                        visible: value.visible,
                        currency: value.currency,
                        processingFee: value.processingFee,
                        recommended: value.recommended,
                        invoiceDescription: value.invoiceDescription,
                        role: value.role,
                      });
                      setProcessingFeeEnabled(value.processingFee);
                      break;

                    case "delete":
                      Modal.confirm({
                        title: Locale.get(
                          "Billing.billingManagement.caseDeleteTitle"
                        ),
                        content: Locale.get(
                          "Billing.billingManagement.caseDeleteContent"
                        ),
                        onOk: () => {
                          deleteSubscription(value._id);
                        },
                      });
                      break;

                    default:
                      break;
                  }
                }}
              >
                <Menu.Item
                  key="editSubscription"
                  style={{ padding: "8px 12px" }}
                >
                  {Locale.get("Billing.billingManagement.subModalTitle_1")}
                </Menu.Item>
                <Menu.Item
                  key="delete"
                  style={{ padding: "8px 12px", color: "red" }}
                >
                  {Locale.get("Billing.billingManagement.menuItem_0b")}
                </Menu.Item>
              </Menu>
            }
          >
            <a>
              {Locale.get("Billing.billingManagement.tabColumnTitle_0h")}{" "}
              <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const voucherColumns = [
    {
      title: Locale.get("Billing.billingManagement.tabColumnTitle_0"),
      dataIndex: "createdAt",
      key: "createdAt",
      defaultSortOrder: "descend",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      render: (v) => {
        return moment(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_a"),
      dataIndex: "name",
      key: "name",

      ...getColumnSearchProps("name"),
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_b"),
      dataIndex: "code",
      key: "code",
      ...getColumnSearchProps("code"),
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_c"),
      dataIndex: "productsApplied",
      key: "productsApplied",
      // ...getColumnSearchProps("productsApplied"),
      render: (value, record) => {
        return value.map((product, index) => (
          <Tag
            // color="cyan"
            key={index}
            style={{
              textAlign: "center",
              // marginBottom: 8,
            }}
          >
            {product.productName}
          </Tag>
        ));
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_d"),
      dataIndex: "type",
      key: "type",

      render: (v, record) => {
        switch (v) {
          case "percent_off":
            return <div>{record.percentageOff}%</div>;
            break;

          case "amount_off":
            return (
              <Currency
                quantity={record.amountOff / 100}
                currency={record.currency}
                pattern="! #,##0.00"
              />
            );
            break;

          default:
            break;
        }
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_e"),
      dataIndex: "duration",
      key: "duration",

      render: (v, record) => {
        if (v === "once" || v === "forever") {
          return <div>{v.charAt(0).toUpperCase() + v.slice(1)}</div>;
        } else {
          return <div>{record.durationInMonth} months</div>;
        }
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_f"),
      dataIndex: "endDate",
      key: "endDate",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment.unix(a.endDate) - moment.unix(b.endDate),
      render: (v, record) => {
        if (record.limitRedeemDate) {
          return <div>{moment.unix(v).format("YYYY-MM-DD")}</div>;
        } else {
          return <div>-</div>;
        }
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_g"),
      dataIndex: "totalUsageAllow",
      key: "totalUsageAllow",

      render: (v, record) => {
        if (record.limitRedeemUsage) {
          return <div>{v}</div>;
        } else {
          return <div>-</div>;
        }
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_h"),
      dataIndex: "pause",
      key: "pause",

      filterMultiple: false,
      filters: [
        {
          text: (
            <Tag color="green">
              {Locale.get("Billing.voucherTabTable.availabilityTag")}
            </Tag>
          ),
          value: false,
        },
        {
          text: (
            <Tag color="red">
              {Locale.get("Billing.voucherTabTable.pauseTag")}
            </Tag>
          ),
          value: true,
        },
      ],

      onFilter: (value, record) => {
        return record.pause === value;
      },

      render: (value) => {
        switch (value) {
          case false:
            return (
              <Tag color="green">
                {Locale.get("Billing.voucherTabTable.availabilityTag")}
              </Tag>
            );

          case true:
            return (
              <Tag color="red">
                {Locale.get("Billing.voucherTabTable.pauseTag")}
              </Tag>
            );

          default:
            return (
              <Tag color="green">
                {Locale.get("Billing.voucherTabTable.availabilityTag")}
              </Tag>
            );
        }
      },
    },
    {
      title: Locale.get("Billing.voucherTabTable.tabColumnTitle_i"),
      align: "center",
      render: (value, record) => {
        return (
          <Dropdown
            placement="bottomRight"
            trigger={["click"]}
            overlay={
              <Menu
                onClick={(e) => {
                  switch (e.key) {
                    case "voucherUsage":
                      // setVoucherUsageVisible(true);
                      window.open(
                        `https://dashboard.stripe.com/test/coupons/${value.code}`, // <-- Test mode
                        // `https://dashboard.stripe.com/coupons/${value.code}`, // <-- Live mode
                        "_blank"
                      );
                      break;

                    case "editVoucher":
                      setVoucherMode("Edit");
                      setVoucherId(value._id);
                      setVoucherVisible(true);

                      var stringifyProductsApplied = [];
                      var buffer = [...value.productsApplied];

                      buffer.forEach((element) => {
                        element = JSON.stringify(element);

                        stringifyProductsApplied.push(element);
                      });

                      console.log(
                        "stringifyProductsApplied",
                        stringifyProductsApplied
                      );

                      console.log(
                        "voucherEndDate",
                        moment.unix(value.endDate).format("YYYY-MM-DD hh:mm A")
                      );

                      voucherForm.setFieldsValue({
                        voucherName: value.name,
                        voucherCode: value.code,
                        voucherType: value.type,
                        voucherDuration: value.duration,
                        durationInMonth:
                          value.duration === "repeating"
                            ? value.durationInMonth
                            : "",
                        percentageOff:
                          value.type === "percent_off"
                            ? value.percentageOff
                            : "",
                        amountOff: {
                          currency:
                            value.type === "amount_off" ? value.currency : "",
                          discountAmount:
                            value.type === "amount_off"
                              ? value.amountOff / 100
                              : "",
                        },
                        limitRedeemDate: value.limitRedeemDate,
                        voucherEndDate: moment.unix(value.endDate),
                        limitRedeemUsage: value.limitRedeemUsage,
                        voucherUsage: value.limitRedeemUsage
                          ? value.totalUsageAllow
                          : "",
                        productsApplied: stringifyProductsApplied,
                        pause: value.pause,
                      });
                      break;

                    case "delete":
                      Modal.confirm({
                        title: Locale.get(
                          "Billing.voucherTabTable.caseDeleteTitle"
                        ),
                        content: Locale.get(
                          "Billing.voucherTabTable.caseDeleteContent"
                        ),
                        onOk: () => {
                          handleDeleteVoucher(value._id, value.code);
                        },
                      });
                      break;

                    default:
                      break;
                  }
                }}
              >
                {/* <Menu.Item key="voucherUsage" style={{ padding: "8px 12px" }}>
                  Voucher Usage
                </Menu.Item> */}
                <Menu.Item key="editVoucher" style={{ padding: "8px 12px" }}>
                  {Locale.get("Billing.voucherTabTable.editVoucherModalTitle")}
                </Menu.Item>
                <Menu.Item
                  key="delete"
                  style={{ padding: "8px 12px", color: "red" }}
                >
                  {Locale.get("Billing.voucherTabTable.menuDelete")}
                </Menu.Item>
              </Menu>
            }
          >
            <a>
              {Locale.get("Billing.voucherTabTable.tabColumnTitle_i")}{" "}
              <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const voucherUsageColumns = [
    {
      title: "Claimed Date",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
      //   sorter: (a, b) => a.updatedAt?.localeCompare(b.updatedAt),
      //   ...getColumnSearchProps('updatedAt'),
      render: (v) => {
        return moment(v).format("YYYY-MM-DD");
      },
    },
    {
      title: "Order Number",
      dataIndex: "orderNumber",
      key: "orderNumber",
      // sorter: (a, b) => a.orderNumber?.localeCompare(b.orderNumber),
      ...getColumnSearchProps("orderNumber"),
      // render: (v) => (v ? v : '-')
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      // sorter: (a, b) => a.invoiceNumber?.localeCompare(b.invoiceNumber),
      ...getColumnSearchProps("invoiceNumber"),
      // render: (v) => (v ? v : '-')
    },
    {
      title: "Voucher Name",
      dataIndex: "voucherName",
      key: "voucherName",
      // sorter: (a, b) => a.voucherName?.localeCompare(b.voucherName),
      ...getColumnSearchProps("voucherName"),
      // render: (v) => (v ? v : '-')
    },
    {
      title: "Voucher Code",
      dataIndex: "voucherCode",
      key: "voucherCode",
      // sorter: (a, b) => a.voucherCode?.localeCompare(b.voucherCode),
      ...getColumnSearchProps("voucherCode"),
      // render: (v) => (v ? v : '-')
    },
    {
      title: "Full Name",
      dataIndex: "name",
      key: "name",
      // sorter: (a, b) => a.name?.localeCompare(b.name),
      ...getColumnSearchProps("name"),
      // render: (v) => (v ? v : '-')
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      // sorter: (a, b) => a.email?.localeCompare(b.email),
      ...getColumnSearchProps("email"),
      // render: (v) => (v ? v : '-')
    },
  ];

  const billingColumns = [
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_a"),
      dataIndex: "created",
      key: "created",
      defaultSortOrder: "descend",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment.unix(a.created) - moment.unix(b.created),
      render: (v) => {
        return moment.unix(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_b"),
      dataIndex: "orderNumber",
      key: "orderNumber",
      width: 200,
      ...getColumnSearchProps("orderNumber"),
      render: (v, d) => {
        if (d.invoiceStatus === "paid") {
          return (
            <div style={{ cursor: "pointer" }}>
              <CopyOutlined
                style={{
                  marginRight: 8,
                  color: "#1890ff",
                }}
              />
              <a
                style={{ color: "#1890ff", borderBottom: "1px solid #1890ff" }}
                href={d.stripeInvoicePDF}
                target="_blank"
              >
                {v}
              </a>
            </div>
          );
        } else {
          return <div>{v}</div>;
        }
      },
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_c"),
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
      width: 150,

      ...getColumnSearchProps("invoiceNumber"),
      render: (v) => (v ? <div style={{}}>{v}</div> : "-"),
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_d"),
      dataIndex: "customer_name",
      key: "customer_name",
      ...getColumnSearchProps("customer_name"),
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_e"),
      dataIndex: "customer_email",
      key: "customer_email",
      ...getColumnSearchProps("customer_email"),
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_f"),
      dataIndex: "product_name",
      key: "product_name",
      width: 250,
      ...getColumnSearchProps("product_name"),
      render: (v, d) => {
        return (
          <div>
            {v}{" "}
            <Tag
              color={
                d.subscriptionStatus === "active"
                  ? "green"
                  : d.subscriptionStatus === "trialing"
                  ? "blue"
                  : "red"
              }
            >
              {d.subscriptionStatus.charAt(0).toUpperCase() +
                d.subscriptionStatus.slice(1)}
            </Tag>
            {d.subscriptionCancelAtPeriodEnd &&
              d.subscriptionStatus !== "canceled" &&
              `(Cancelation on ${moment
                .unix(d.renewalDate)
                .format("YYYY-MM-DD")})`}
          </div>
        );
      },
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_g"),
      dataIndex: "subscription_interval",
      key: "subscription_interval",
      // ...getColumnSearchProps("subscription_interval"),
      filterMultiple: false,
      filters: [
        { text: "Monthly", value: "month" },
        { text: "Annually", value: "year" },
      ],

      onFilter: (value, record) => {
        return record.subscription_interval === value;
      },
      render: (v) => (v === "month" ? "Monthly" : "Annually"),
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_h"),
      dataIndex: "total",
      key: "total",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.total - b.total,
      render: (v, d) => (
        <Currency
          quantity={v / 100}
          currency={d.currency}
          pattern="! #,##0.00"
        />
      ),
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_i"),
      dataIndex: "renewalDate",
      key: "renewalDate",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment.unix(a.renewalDate) - moment.unix(b.renewalDate),

      render: (v) => {
        return moment.unix(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_j"),
      dataIndex: "invoiceStatus",
      key: "invoiceStatus",

      filterMultiple: false,
      filters: [
        {
          text: (
            <Tag color="green">
              {Locale.get("Billing.billingTabTable.paidTag")}
            </Tag>
          ),
          value: "paid",
        },
        {
          text: (
            <Tag color="blue">
              {Locale.get("Billing.billingTabTable.openTag")}
            </Tag>
          ),
          value: "open",
        },
        // { text: <Tag color="yellow">Draft</Tag>, value: "draft" },
        // { text: <Tag>Uncollectible</Tag>, value: "uncollectible" },
        // { text: <Tag color="red">Void</Tag>, value: "void" },
      ],

      onFilter: (value, record) => {
        return record.invoiceStatus === value;
      },

      render: (value) => {
        switch (value) {
          case "paid":
            return (
              <Tag color="green">
                {Locale.get("Billing.billingTabTable.paidTag")}
              </Tag>
            );

          case "open":
            return (
              <Tag color="blue">
                {Locale.get("Billing.billingTabTable.openTag")}
              </Tag>
            );

          // case "draft":
          //   return <Tag color="yellow">Draft</Tag>;

          // case "uncollectible":
          //   return <Tag>Uncollectible</Tag>;

          default:
            // return <Tag color="red">Void</Tag>;
            return (
              <Tag color="blue">
                {Locale.get("Billing.billingTabTable.openTag")}
              </Tag>
            );
        }
      },
    },
    {
      title: Locale.get("Billing.billingTabTable.tableColumnTitle_k"),
      align: "center",
      render: (value, record) => {
        return (
          <Dropdown
            placement="bottomRight"
            trigger={["click"]}
            overlay={
              <Menu
                onClick={(e) => {
                  switch (e.key) {
                    case "sendInvoice":
                      Modal.confirm({
                        title: "Send Invoice?",
                        onOk: () => {
                          SendInvoice(value.id);
                        },
                      });

                      break;

                    case "requestPayment":
                      form.setFieldsValue({
                        deductAmount: value.total / 100,
                      });
                      setDeductAmountVisible(true);
                      break;

                    case "cancelUserSubscription":
                      Modal.confirm({
                        title: `Confirm to cancel ${
                          record.invoice.customer_name
                        }' subscription (${record.productDetail.name} - ${
                          record.subscriptionDetail.interval === "month"
                            ? "Monthly"
                            : "Annually"
                        }) ?`,

                        content: `Note that this user will lose access to the resources provided by the current subscription on ${moment
                          .unix(record.subscriptionDetail.current_period_end)
                          .format(
                            "YYYY-MM-DD"
                          )} as it will be automatically canceled. Past subscription fees won't be refunded.`,
                        onOk: async () => {
                          const payload = {
                            customerId: record.invoice.customer,
                          };
                          adminCancelUserSubscription(payload)
                            .then((res) => {
                              if (res.status === 200) {
                                message.success(
                                  `${
                                    record.invoice.customer_name
                                  }' subscription (${
                                    record.productDetail.name
                                  } - ${
                                    record.subscriptionDetail.interval ===
                                    "month"
                                      ? "Monthly"
                                      : "Annually"
                                  }) has been successfully canceled.`
                                );
                                console.log("res", res);
                                setTimeout(() => {
                                  window.location.reload();
                                }, 1000);
                              }
                            })
                            .catch((ex) => {
                              Modal.error({
                                title: ex.message,
                              });
                            });
                        },
                      });
                      break;

                    default:
                      break;
                  }
                }}
              >
                {/* <Menu.Item key="viewDetail" style={{ padding: "8px 12px" }}>
                    View Detail
                  </Menu.Item> */}
                {/* <Menu.Item key="sendInvoice" style={{ padding: "8px 12px" }}>
                  Send Invoice
                </Menu.Item> */}
                {/* <Menu.Item
                  key="requestPayment"
                  disabled={record.status === "paid" ? true : false}
                  style={{ padding: "8px 12px" }}
                >
                  Request payment
                </Menu.Item> */}
                <Menu.Item
                  key="cancelUserSubscription"
                  disabled={
                    record.invoice.status === "paid"
                      ? (record.subscriptionDetail.status === "active" ||
                          record.subscriptionDetail.status === "trialing") &&
                        record.subscriptionDetail.cancel_at_period_end === false
                        ? false
                        : true
                      : true
                  }
                  style={{ padding: "8px 12px" }}
                >
                  {Locale.get("Billing.billingTabTable.menuCancelSubscription")}
                </Menu.Item>
              </Menu>
            }
          >
            <a>
              {Locale.get("Billing.billingTabTable.tableColumnTitle_k")}{" "}
              <DownOutlined />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const invoiceColumns = [
    {
      title: Locale.get("Billing.invoiceTabTable.tabColumnTitle_a"),
      dataIndex: "createdAt",
      key: "createdAt",
      defaultSortOrder: "descend",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),

      render: (v) => {
        return moment(v).format("YYYY-MM-DD");
      },
    },
    {
      title: Locale.get("Billing.invoiceTabTable.tabColumnTitle_b"),
      dataIndex: "orderNumber",
      key: "orderNumber",

      ...getColumnSearchProps("orderNumber"),
    },
    {
      title: Locale.get("Billing.invoiceTabTable.tabColumnTitle_c"),
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",

      ...getColumnSearchProps("invoiceNumber"),
      render: (v) =>
        v ? (
          <div style={{ cursor: "pointer" }}>
            <CopyOutlined
              style={{
                marginRight: 8,
                color: "#1890ff",
              }}
            />
            <a
              onClick={async () => {
                console.log("click", v);
                const invoiceNumber = v;

                history.push(
                  `invoice/subscription?invoiceNumber=${invoiceNumber}`
                );
              }}
              style={{ color: "#1890ff", borderBottom: "1px solid #1890ff" }}
            >
              {v}
            </a>
          </div>
        ) : (
          "-"
        ),
    },
    {
      title: Locale.get("Billing.invoiceTabTable.tabColumnTitle_d"),
      dataIndex: "userName",
      key: "userName",

      ...getColumnSearchProps("userName"),
    },
    {
      title: Locale.get("Billing.invoiceTabTable.tabColumnTitle_e"),
      dataIndex: "userEmail",
      key: "userEmail",

      ...getColumnSearchProps("userEmail"),
    },
    {
      title: Locale.get("Billing.invoiceTabTable.tabColumnTitle_f"),
      dataIndex: "amount",
      key: "amount",
      sortDirections: ["descend", "ascend"],
      sorter: (a, b) => a.amount - b.amount,
      render: (v, d) => (
        <Currency
          quantity={v / 100}
          currency={d.currency}
          pattern="! #,##0.00"
        />
      ),
    },
  ];

  const SubscriptionModal = (
    <Modal
      visible={subscriptionVisible}
      title={
        subscriptionMode === "Add"
          ? Locale.get("Billing.billingManagement.subModalTitle_0")
          : Locale.get("Billing.billingManagement.subModalTitle_1")
      }
      afterClose={() => {
        subscriptionForm.resetFields();
        setSubscriptionMode("Add");
        setSubscriptionId("");
      }}
      onCancel={() => {
        setSubscriptionVisible(false);
      }}
      onOk={HandleSubscription}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <Form form={subscriptionForm} {...formItemLayout}>
        <Form.Item
          label={Locale.get("Billing.billingManagement.tabColumnTitle_0a")}
          name={"name"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.billingManagement.billManagementForm.nameRuleMsg"
              ),
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.billingManagement.addSubItem_0a")}
          name={"currency"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.billingManagement.billManagementForm.currencyRuleMsg"
              ),
            },
          ]}
        >
          <Select
            placeholder={Locale.get(
              "Billing.billingManagement.currencyPlaceholder"
            )}
            disabled={subscriptionMode === "Edit" ? true : false}
            style={{ width: "100%" }}
          >
            <Select.Option value="myr">MYR</Select.Option>
            <Select.Option value="usd">USD</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.billingManagement.tabColumnTitle_0c")}
          name={"pricePerMonth"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.billingManagement.billManagementForm.ppmRuleMsg"
              ),
            },
          ]}
        >
          <InputNumber
            style={{
              width: "100%",
            }}
            min={0}
            precision={2}
            disabled={subscriptionMode === "Edit" ? true : false}
          />
        </Form.Item>

        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => {
            return (
              <Form.Item
                label={Locale.get(
                  "Billing.billingManagement.tabColumnTitle_0d"
                )}
                name={"pricePerYear"}
                rules={[
                  {
                    required: true,
                    message: Locale.get(
                      "Billing.billingManagement.billManagementForm.ppyRuleMsg"
                    ),
                  },
                ]}
              >
                <InputNumber
                  style={{
                    width: "100%",
                  }}
                  min={0}
                  precision={2}
                  disabled={subscriptionMode === "Edit" ? true : false}
                />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.billingManagement.switchFormItem_0b")}
          name={"role"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.billingManagement.billManagementForm.roleRuleMsg"
              ),
            },
          ]}
        >
          <Select
            placeholder={Locale.get(
              "Billing.billingManagement.rolePlaceholder"
            )}
            // disabled={subscriptionMode === "Edit" ? true : false}
            style={{ width: "100%" }}
            options={roles}
          ></Select>
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.billingManagement.switchFormItem_0c")}
          name={"invoiceDescription"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.billingManagement.billManagementForm.invoiceDescRuleMsg"
              ),
            },
          ]}
        >
          <Input.TextArea autoSize={{ minRows: 3, maxRows: 3 }} />
        </Form.Item>

        <Form.List name="description">
          {(fields, { add, remove }) => {
            return (
              <div>
                {fields.map((field, index) => (
                  <Form.Item
                    {...(index === 0
                      ? formItemLayout
                      : formItemLayoutWithOutLabel)}
                    label={
                      index === 0
                        ? Locale.get(
                            "Billing.billingManagement.tabColumnTitle_0b"
                          )
                        : ""
                    }
                    required={true}
                    key={field.key}
                  >
                    <Form.Item
                      {...field}
                      validateTrigger={["onChange", "onBlur"]}
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: Locale.get(
                            "Billing.billingManagement.billManagementForm.descRuleMsg"
                          ),
                        },
                      ]}
                      noStyle
                    >
                      <Input
                        placeholder={Locale.get(
                          "Billing.billingManagement.descPlaceholder"
                        )}
                        style={{ width: "80%" }}
                        disabled={loading}
                      />
                    </Form.Item>
                    {fields.length > 1 ? (
                      <MinusCircleOutlined
                        className="dynamic-delete-button"
                        style={{ margin: "0 8px" }}
                        onClick={() => {
                          if (!loading) {
                            remove(field.name);
                          }
                        }}
                      />
                    ) : null}
                  </Form.Item>
                ))}
                <Form.Item {...formItemLayoutWithOutLabel}>
                  <Button
                    type="dashed"
                    onClick={() => {
                      if (!loading) {
                        add();
                      }
                    }}
                    style={{ width: "60%" }}
                  >
                    <PlusOutlined />{" "}
                    {Locale.get("Billing.billingManagement.addDescButton")}
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>

        <Form.Item
          name="processingFee"
          label={Locale.get("Billing.billingManagement.tabColumnTitle_0e")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
          extra={
            processingFeeEnabled &&
            Locale.get("Billing.billingManagement.processingFeeExtra")
          }
        >
          <Switch
            size="default"
            value={processingFeeEnabled}
            onChange={(e) => {
              setProcessingFeeEnabled(e);
            }}
            disabled={subscriptionMode === "Edit" ? true : false}
          />
        </Form.Item>

        <Form.Item
          name="trial"
          label={Locale.get("Billing.billingManagement.switchFormItem_0a")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
        >
          <Switch
            size="default"
            // disabled={subscriptionMode === "Edit" ? true : false}
          />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(curr, prev) => curr.trial !== prev.trial}
        >
          {(e) => {
            const value = e.getFieldValue("trial");

            return (
              <Form.Item
                hidden={!value}
                name="trialEndDate"
                label={Locale.get(
                  "Billing.billingManagement.tabColumnTitle_0f"
                )}
                rules={[
                  {
                    required: value ? true : false,
                    message: Locale.get(
                      "Billing.billingManagement.errMsgTrial"
                    ),
                  },
                ]}
                extra={Locale.get(
                  "Billing.billingManagement.trialEndDateExtra"
                )}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    // disable today's date
                    if (
                      current &&
                      current.format("DD/MM/YYYY") ===
                        moment().format("DD/MM/YYYY")
                    ) {
                      return true;
                    }
                    // disable tomorrow's date
                    if (
                      current &&
                      current.format("DD/MM/YYYY") ===
                        moment().add(1, "days").format("DD/MM/YYYY")
                    ) {
                      return true;
                    }
                    // disable dates before today's date
                    return current && current < moment().startOf("day");
                  }}
                />
              </Form.Item>

              // <Form.Item label="Trial Duration" hidden={!value}>
              //   <Form.Item
              //     name="trialDuration"
              //     hidden={!value}
              //     rules={[
              //       {
              //         required: value ? true : false,
              //         message: "Trial Duration is required.",
              //       },
              //     ]}
              //     noStyle
              //   >
              //     <InputNumber
              //       min={1}
              //       disabled={subscriptionMode === "Edit" ? true : false}
              //     />
              //   </Form.Item>
              //   <span
              //     className="ant-form-text"
              //     style={{
              //       marginLeft: 8,
              //     }}
              //   >
              //     days
              //   </span>
              // </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          name="visible"
          label={Locale.get("Billing.billingManagement.visibleTag")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
          // extra={subscriptionId}
        >
          <Switch size="default" disabled={loading} />
        </Form.Item>

        <Form.Item
          name="recommended"
          label={Locale.get("Billing.billingManagement.recommendedTag")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
        >
          <Switch size="default" disabled={loading} />
        </Form.Item>
      </Form>
    </Modal>
  );

  const VoucherModal = (
    <Modal
      visible={voucherVisible}
      title={
        voucherMode === "Add"
          ? Locale.get("Billing.voucherTabTable.addVoucherModalTitle")
          : Locale.get("Billing.voucherTabTable.editVoucherModalTitle")
      }
      afterClose={() => {
        voucherForm.resetFields();
        setVoucherMode("Add");
        setVoucherId("");
      }}
      onCancel={() => {
        setVoucherVisible(false);
      }}
      onOk={HandleVoucher}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <Form
        form={voucherForm}
        {...formItemLayout}
        initialValues={{
          voucherDuration: "once",
          voucherType: "percent_off",
        }}
      >
        <Form.Item
          label={Locale.get("Billing.voucherTabTable.voucherForm.voucherName")}
          name={"voucherName"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.voucherTabTable.voucherForm.nameRuleMsg"
              ),
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.voucherTabTable.voucherForm.voucherCode")}
          name={"voucherCode"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.voucherTabTable.voucherForm.codeRuleMsg"
              ),
            },
            {
              validator: CheckVoucherCodeExists,
            },
            {
              validator: validateSpecialCharacters,
            },
          ]}
        >
          <Input disabled={voucherMode === "Edit" ? true : false} />
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.voucherTabTable.voucherForm.voucherType")}
          name={"voucherType"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.voucherTabTable.voucherForm.typeRuleMsg"
              ),
            },
          ]}
        >
          <Radio.Group
            disabled={voucherMode === "Edit" ? true : false}
            onChange={(e) => console.log(e)}
          >
            <Radio value="percent_off">
              {Locale.get("Billing.voucherTabTable.voucherForm.radioPercent")}
            </Radio>
            <Radio value="amount_off">
              {Locale.get("Billing.voucherTabTable.voucherForm.radioFa")}
            </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(curr, prev) => curr.voucherType !== prev.voucherType}
        >
          {(e) => {
            const voucherType = e.getFieldValue("voucherType");

            if (voucherType === "percent_off") {
              return (
                <>
                  <Form.Item
                    label={Locale.get(
                      "Billing.voucherTabTable.voucherForm.voucherPercentageOff"
                    )}
                  >
                    <Form.Item
                      name="percentageOff"
                      rules={[
                        {
                          required:
                            voucherType === "percent_off" ? true : false,
                          message: Locale.get(
                            "Billing.voucherTabTable.voucherForm.poRuleMsg"
                          ),
                        },
                      ]}
                      noStyle
                    >
                      <InputNumber
                        disabled={voucherMode === "Edit" ? true : false}
                        min={1}
                        max={100}
                      />
                    </Form.Item>
                    <span
                      className="ant-form-text"
                      style={{
                        marginLeft: 8,
                      }}
                    >
                      %
                    </span>
                  </Form.Item>
                </>
              );
            } else {
              return (
                <>
                  <Form.Item
                    label={Locale.get(
                      "Billing.billingManagement.discountAmount"
                    )}
                    rules={[
                      {
                        required: true,
                        message: Locale.get(
                          "Billing.billingManagement.errMsgDiscount"
                        ),
                      },
                    ]}
                  >
                    <Input.Group compact>
                      <Form.Item
                        name={["amountOff", "currency"]}
                        noStyle
                        initialValue="myr"
                        rules={[
                          {
                            required: true,
                            message: "Currency is required",
                          },
                        ]}
                      >
                        <Select
                          placeholder="Select Currency"
                          style={{ width: "30%" }}
                          disabled={voucherMode === "Edit" ? true : false}
                        >
                          <Select.Option value="myr">MYR</Select.Option>
                          <Select.Option value="usd">USD</Select.Option>
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name={["amountOff", "discountAmount"]}
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: Locale.get(
                              "Billing.billingManagement.discountAmount"
                            ),
                          },
                          {
                            pattern: RegExp(
                              /(?:0\.[0-9]{1,2}|[1-9]{1}[0-9]*(\.[0-9]{1,2})?|0)$/
                            ),
                            message: "Amount must be number only",
                          },
                        ]}
                      >
                        <InputNumber
                          style={{ width: "70%" }}
                          min={1}
                          precision={2}
                          placeholder="10.00"
                          disabled={voucherMode === "Edit" ? true : false}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </>
              );
            }
          }}
        </Form.Item>

        <Form.Item
          label={Locale.get(
            "Billing.voucherTabTable.voucherForm.productApplied"
          )}
          name="productsApplied"
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.voucherTabTable.voucherForm.productRuleMsg"
              ),
            },
          ]}
        >
          <Select
            mode="multiple"
            disabled={voucherMode === "Edit" ? true : false}
            allowClear
          >
            {voucherMode === "Edit"
              ? allProducts.map((selection) => (
                  <Select.Option
                    value={JSON.stringify({
                      stripeProductId: selection.stripeProductId,
                      productName: selection.name,
                    })}
                    key={selection.stripeProductId}
                  >
                    {selection.name}
                  </Select.Option>
                ))
              : data.map((selection) => (
                  <Select.Option
                    value={JSON.stringify({
                      stripeProductId: selection.stripeProductId,
                      productName: selection.name,
                    })}
                    key={selection.stripeProductId}
                  >
                    {selection.name}
                  </Select.Option>
                ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={Locale.get("Billing.voucherTabTable.voucherForm.duration")}
          name={"voucherDuration"}
          rules={[
            {
              required: true,
              message: Locale.get(
                "Billing.voucherTabTable.voucherForm.durationRuleMsg"
              ),
            },
          ]}
        >
          <Radio.Group
            disabled={voucherMode === "Edit" ? true : false}
            onChange={(e) => console.log(e)}
          >
            <Radio value="once">
              {Locale.get("Billing.voucherTabTable.voucherForm.radioOnce")}
            </Radio>
            <Radio value="forever">
              {Locale.get("Billing.voucherTabTable.voucherForm.radioForever")}
            </Radio>
            <Radio value="repeating">
              {Locale.get("Billing.voucherTabTable.voucherForm.radioRepeat")}
            </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(curr, prev) =>
            curr.voucherDuration !== prev.voucherDuration
          }
        >
          {(e) => {
            const value = e.getFieldValue("voucherDuration");

            return (
              <Form.Item
                label={Locale.get(
                  "Billing.voucherTabTable.voucherForm.noMonths"
                )}
                hidden={value !== "repeating"}
              >
                <Form.Item
                  name="durationInMonth"
                  hidden={!value}
                  rules={[
                    {
                      required: value === "repeating" ? true : false,
                      message: "Duration in month is required.",
                    },
                  ]}
                  noStyle
                >
                  <InputNumber
                    disabled={voucherMode === "Edit" ? true : false}
                    min={1}
                  />
                </Form.Item>
                <span
                  className="ant-form-text"
                  style={{
                    marginLeft: 8,
                  }}
                >
                  {Locale.get("Billing.voucherTabTable.voucherForm.months")}
                </span>
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          name="limitRedeemDate"
          label={Locale.get("Billing.voucherTabTable.voucherForm.lRD")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
        >
          <Switch
            size="default"
            disabled={voucherMode === "Edit" ? true : false}
          />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(curr, prev) =>
            curr.limitRedeemDate !== prev.limitRedeemDate
          }
        >
          {(e) => {
            const value = e.getFieldValue("limitRedeemDate");

            return (
              <>
                <Form.Item
                  hidden={!value}
                  name="voucherEndDate"
                  label={Locale.get(
                    "Billing.voucherTabTable.voucherForm.lrdHiddenLabel"
                  )}
                  rules={[
                    {
                      required: value ? true : false,
                      message: Locale.get(
                        "Billing.voucherTabTable.voucherForm.lrdRuleMsg"
                      ),
                    },
                  ]}
                  // initialValue={moment().format("YYYY-MM-DD")}
                >
                  <DatePicker
                    format={"YYYY-MM-DD hh:mm A"}
                    showTime
                    disabled={voucherMode === "Edit" ? true : false}
                    disabledDate={(e) => e && e < moment().startOf("day")}
                  />
                </Form.Item>
              </>
            );
          }}
        </Form.Item>

        <Form.Item
          name="limitRedeemUsage"
          label={Locale.get("Billing.voucherTabTable.voucherForm.lRU")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
        >
          <Switch
            size="default"
            disabled={voucherMode === "Edit" ? true : false}
          />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(curr, prev) =>
            curr.limitRedeemUsage !== prev.limitRedeemUsage
          }
        >
          {(e) => {
            const value = e.getFieldValue("limitRedeemUsage");

            return (
              <>
                <Form.Item
                  label={Locale.get(
                    "Billing.voucherTabTable.voucherForm.lruHiddenLabel"
                  )}
                  hidden={!value}
                  extra={Locale.get(
                    "Billing.voucherTabTable.voucherForm.lruExtra"
                  )}
                >
                  <Form.Item
                    name="voucherUsage"
                    rules={[
                      {
                        required: value ? true : false,
                        message: Locale.get(
                          "Billing.voucherTabTable.voucherForm.lruRuleMsg"
                        ),
                      },
                    ]}
                    noStyle
                  >
                    <InputNumber
                      min={1}
                      disabled={voucherMode === "Edit" ? true : false}
                    />
                  </Form.Item>
                  <span
                    className="ant-form-text"
                    style={{
                      marginLeft: 8,
                    }}
                  >
                    {Locale.get("Billing.voucherTabTable.voucherForm.times")}
                  </span>
                </Form.Item>
              </>
            );
          }}
        </Form.Item>
        <Form.Item
          name="pause"
          label={Locale.get("Billing.voucherTabTable.voucherForm.pause")}
          valuePropName="checked"
          className="switch-handle-style"
          initialValue={false}
        >
          <Switch size="default" disabled={loading} />
        </Form.Item>
      </Form>
    </Modal>
  );

  const VoucherUsageModal = (
    <Modal
      centered
      width={window.innerWidth < ScreenSize.xl ? "100%" : 1150}
      visible={voucherUsageVisible}
      title={"Voucher Usage"}
      afterClose={() => {}}
      onCancel={() => {
        setVoucherUsageVisible(false);
      }}
      footer={null}
      onOk={HandleVoucher}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <Row justify="end" style={{ marginBottom: 16 }}>
        <Col>
          <CSVLink
            data={csvDataVoucherUsage}
            headers={csvHeaderVoucherUsage}
            filename={`${moment().format("DD-MMM-YYYY")} Voucher Usage.csv`}
            onClick={() => {
              generateVoucherCSV();
            }}
          >
            <Button
              icon={<CloudDownloadOutlined />}
              type="primary"
              disabled={voucherUsageData.length === 0 ? true : false}
            >
              Export CSV
            </Button>
          </CSVLink>
        </Col>
      </Row>

      <Table
        size="small"
        rowKey="_id"
        bordered
        columns={voucherUsageColumns}
        loading={loading}
        dataSource={voucherUsageData}
        scroll={{ scrollToFirstRowOnChange: true, x: true }}
      />
    </Modal>
  );

  const DeductAmountModal = (
    <Modal
      visible={deductAmountVisible}
      title="Deduct Amount"
      afterClose={() => form.resetFields()}
      onCancel={() => {
        setDeductAmountVisible(false);
      }}
      onOk={HandleDeductAmount}
      okButtonProps={{ loading: loading }}
      cancelButtonProps={{ disabled: loading }}
    >
      <Form form={form} {...formItemLayout}>
        <Form.Item
          label="Deduct Amount"
          name={"deductAmount"}
          rules={[
            {
              required: true,
              message: "Deduct Amount is required",
            },
          ]}
        >
          <InputNumber
            style={{
              width: "100%",
            }}
            // max={100}
            min={0}
            precision={2}
          />
        </Form.Item>
      </Form>
    </Modal>
  );

  const ManagementTab = (
    <div>
      <Row justify="end" gutter={8} style={{ marginBottom: 24 }}>
        {/* <Col>
          <Button
            type="primary"
            style={{ height: 40 }}
            icon={<RedoOutlined />}
            loading={loading}
            onClick={() => {
              setLoading(true);
              syncProducts()
                .then((res) => {
                  console.log("res syncProducts", res);
                  if (res.status === 200) {
                    message.success("Product Sync Successful!");

                    setTimeout(() => {
                      setLoading(false);
                      window.location.reload();
                    }, 2000);
                  }
                })
                .catch((ex) => {
                  setLoading(false);
                  Modal.error({
                    title: ex.message,
                  });
                });
            }}
          >
            Sync
          </Button>
        </Col> */}
        <Col>
          <Button
            type="primary"
            style={{ height: 40 }}
            icon={<PlusOutlined />}
            onClick={() => {
              setSubscriptionVisible(true);
            }}
          >
            {Locale.get("Billing.billingManagement.subModalTitle_0")}
          </Button>
        </Col>
      </Row>
      <Table
        size="small"
        rowKey="_id"
        bordered
        columns={columns}
        loading={loading}
        dataSource={data}
        scroll={{ scrollToFirstRowOnChange: true, x: true }}
      />
    </div>
  );

  const VoucherTab = (
    <div>
      <Row justify="end" style={{ marginBottom: 24 }}>
        <Col>
          <Button
            type="primary"
            style={{ height: 40 }}
            icon={<PlusOutlined />}
            onClick={() => setVoucherVisible(true)}
          >
            {Locale.get("Billing.voucherTabTable.addVoucherModalTitle")}
          </Button>
        </Col>
      </Row>
      <Table
        size="small"
        rowKey="_id"
        bordered
        columns={voucherColumns}
        loading={loading}
        dataSource={voucherData}
        scroll={{ scrollToFirstRowOnChange: true, x: true }}
      />
    </div>
  );

  const BillingTab = (
    <div>
      <Row justify="end" style={{ marginBottom: 24 }}>
        {/* <Col>
          <Title marginBottom="32px">Billing Management</Title>
        </Col> */}
        <Col>
          <Row gutter={24}>
            <Col>
              <CSVLink
                data={csv_data}
                headers={csv_header}
                filename={`${moment().format("DD-MMM-YYYY")} Billing.csv`}
                onClick={generateCSV}
              >
                <Button type="primary" icon={<CloudDownloadOutlined />}>
                  {Locale.get("Billing.billingTabTable.csvButton")}
                </Button>
              </CSVLink>
            </Col>

            <Col>
              <DatePicker.RangePicker
                value={dateRange}
                disabledDate={(e) => e && e > moment().endOf("day")}
                // defaultPickerValue={dateRange}
                // defaultPickerValue={[
                //   moment().subtract(1, "month").startOf("day"),
                //   moment().endOf("day")
                // ]}
                onChange={(e) => {
                  console.log(e, 509);

                  if (e !== null) {
                    setDateRange(e);
                    BillingList(e);
                  } else {
                    setDateRange([
                      moment().subtract(1, "month").startOf("day"),
                      moment().endOf("day"),
                    ]);

                    BillingList([
                      moment().subtract(1, "month").startOf("day"),
                      moment().endOf("day"),
                    ]);
                  }
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        justify="center"
        align="middle"
        style={{ textAlign: "center", color: "grey" }}
      >
        {Locale.get("Billing.billingTabTable.rowHeader_0")}
      </Row>
      <Row
        justify="center"
        align="middle"
        style={{ marginBottom: 8, textAlign: "center", color: "grey" }}
      >
        {Locale.get("Billing.billingTabTable.rowHeader_1")}
      </Row>
      <Table
        size="small"
        rowKey="_id"
        bordered
        columns={billingColumns}
        loading={billingLoading}
        dataSource={billingData}
        scroll={{ scrollToFirstRowOnChange: true, x: true }}
      />
    </div>
  );

  const InvoiceTab = (
    <div>
      <Row justify="end" style={{ marginBottom: 24 }}>
        {/* <Col>
          <Title marginBottom="32px">Billing Management</Title>
        </Col> */}
        <Col>
          <Row gutter={24}>
            <Col>
              <CSVLink
                data={csvDataInvoice}
                headers={csvHeaderInvoice}
                filename={`${moment().format("DD-MMM-YYYY")} Invoice.csv`}
                onClick={generateInvoiceCSV}
              >
                <Button type="primary" icon={<CloudDownloadOutlined />}>
                  {Locale.get("Billing.invoiceTabTable.csvButton")}
                </Button>
              </CSVLink>
            </Col>

            <Col>
              <DatePicker.RangePicker
                value={dateRangeInvoice}
                disabledDate={(e) => e && e > moment().endOf("day")}
                // defaultPickerValue={dateRangeInvoice}
                // defaultPickerValue={[
                //   moment().subtract(1, "month").startOf("day"),
                //   moment().endOf("day")
                // ]}
                onChange={(e) => {
                  console.log(e, 509);

                  if (e !== null) {
                    setDateRangeInvoice(e);
                    InvoiceList(e);
                  } else {
                    setDateRangeInvoice([
                      moment().subtract(1, "month").startOf("day"),
                      moment().endOf("day"),
                    ]);

                    InvoiceList([
                      moment().subtract(1, "month").startOf("day"),
                      moment().endOf("day"),
                    ]);
                  }
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Table
        size="small"
        rowKey="_id"
        bordered
        columns={invoiceColumns}
        loading={invoiceLoading}
        dataSource={invoiceData}
        scroll={{ scrollToFirstRowOnChange: true, x: true }}
      />
    </div>
  );

  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        /* style={{ marginBottom: '32px' }} */
      >
        <ClickableTextButton
          text={Locale.get("Billing.billingManagement.backButton")}
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
        {/* <Button
          type="primary"
          icon={<CheckOutlined />}
          onClick={handleOnSaveButtonClick}>
          Save
        </Button> */}
      </Row>

      <Title marginBottom="32px">
        {Locale.get("Billing.billingManagement.pageTitle")}
      </Title>

      <Tabs>
        <Tabs.TabPane
          tab={Locale.get("Billing.billingManagement.tabTitle_0")}
          key="item-0"
        >
          {ManagementTab}
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={Locale.get("Billing.voucherTabTable.tabTitle_1")}
          key="item-1"
        >
          {VoucherTab}
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={Locale.get("Billing.billingTabTable.tabTitle_2")}
          key="item-2"
        >
          {BillingTab}
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={Locale.get("Billing.invoiceTabTable.tabTitle_3")}
          key="item-3"
        >
          {InvoiceTab}
        </Tabs.TabPane>
      </Tabs>

      {SubscriptionModal}
      {VoucherModal}
      {VoucherUsageModal}
      {DeductAmountModal}
    </div>
  );
};

export default withAppContext(BillingManagement);
